import axios from 'axios'
import Cookies from 'js-cookie'

let headers = {
  'Content-Type': 'application/json',
  'X-CSRFToken': Cookies.get('csrftoken'),
};

let token = localStorage.getItem(`app_${location.host}-token`);

if (token) {
  token = JSON.parse(token);
  headers['Authorization'] = `Token ${token.value}`;
}

export default axios.create({
  baseURL: '/api',
  timeout: 60000 * 3, // 3 min
  headers: headers,
  paramsSerializer: {
    indexes: null,
  }
})
